import { Typography, styled } from '@mui/material';

export const StyledHeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 600,
  lineHeight: theme.typography.pxToRem(20),
}));
